import Vue from 'vue'
import App from '../views/App.vue'
import router from '../router'
import store from '../store'
import axios from 'axios'
import moment from 'moment'
import vuetify from '../plugins/vuetify'
import VueAxios from 'vue-axios'
import AppLayout from "../layouts/AppLayout.vue"
import VueAlertify from 'vue-alertify'
import i18n from "./i18n";
import ImageUploader from 'vue-image-upload-resize'
import User from "../models/User"
import select2 from "select2"
import VeeValidate from 'vee-validate'

axios.defaults.headers.common = {
  "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")
    .getAttribute('content'),
  "Access-Control-Allow-Origin": "*"
}

Vue.use(ImageUploader);
Vue.component('AppLayout', AppLayout)
Vue.use(VeeValidate, {
  mode: 'passive'
})

VeeValidate.setMode('passive');
Vue.use(VueAxios, axios)
Vue.use(VueAlertify, {
  notifier: {
    delay: 10,
    position: 'bottom-right',
    closeButton: false
  }
})

Vue.filter('toLongDate', function (value) {
  if(value) {
    return moment(String(value)).format('LL')
  } else {
    return ''
  }
});

Vue.filter('toReformatDay', function (value) {
  if(value) {
    return moment(String(value)).format('DD/MM/YYYY')
  } else {
    return ''
  }
});

Vue.filter('toLongDateTime', function (value) {
  if(value) {
    return moment(String(value)).format('LLL')
  } else {
    return ''
  }
});

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0
  })
  return formatter.format(value)
})

Vue.filter('toCurrencyDecimals', function (value) {
  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
  })
  return formatter.format(value)
})

Vue.filter('toNumberFormat', function (value) {
  if(value) {
    return new Intl.NumberFormat().format(value)
  } else {
    return 0
  }
})

Vue.filter('firstLetter', function (value) {
  if(value) {
    return value.charAt(0)
  } else {
    return '-'
  }
})

document.addEventListener('DOMContentLoaded', () => {
  Vue.prototype.$user = new User();
  Vue.prototype.$tenantName = document.querySelector('body').dataset.tenantName;

  const app = new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
});